import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function () {
    var cookie_name = "dcm_brand_switch_modal";

    var modalElement = document.getElementById('brandSwitchModal');
    if (!modalElement) {
        return;
    }

    var cookies = document.cookie.split(';').map(cookie => cookie.trim());
    var hasBeenShown = cookies.some(cookie => cookie.startsWith(cookie_name + '='));

    if (hasBeenShown) {
        return;
    }

    var modalInstance = new Modal(modalElement);
    modalInstance.show();

    document.cookie = cookie_name + "=modalShown; path=/; max-age=" + (60 * 60 * 24 * 365);
});
